export const showCaseContent = {
	ocupation: 'Front End Developer',
};
